import { withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "tab-header" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "tab-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_income_chart = _resolveComponent("income-chart")!
  const _component_pots_chart = _resolveComponent("pots-chart")!
  const _component_sub_section = _resolveComponent("sub-section")!

  return (_openBlock(), _createBlock(_component_sub_section, {
    title: "Can you still expect to get what you want?",
    helpTitle: "What to take each year",
    helpText: _ctx.HelpText.incomeAndPotsCharts()
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          _createElementVNode("li", {
            role: "button",
            tabindex: "0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onTabClick(0))),
            onKeyup: [
              _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.onTabClick(0)), ["enter"])),
              _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.onTabClick(0)), ["space"]))
            ],
            class: _normalizeClass({
                    'tab-selected': _ctx.selectedTabIndex == 0,
                    'tab-unselected': _ctx.selectedTabIndex != 0
                  }),
            "aria-label": _ctx.incomeChartDescription
          }, " Income ", 42, _hoisted_3),
          _createElementVNode("li", {
            role: "button",
            tabindex: "0",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onTabClick(1))),
            onKeyup: [
              _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.onTabClick(1)), ["enter"])),
              _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.onTabClick(1)), ["space"]))
            ],
            class: _normalizeClass({
                    'tab-selected': _ctx.selectedTabIndex == 1,
                    'tab-unselected': _ctx.selectedTabIndex != 1
                  }),
            "aria-label": _ctx.potsChartDescription
          }, " Your Pots ", 42, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createVNode(_component_income_chart, null, null, 512), [
            [_vShow, _ctx.selectedTabIndex == 0]
          ]),
          _withDirectives(_createVNode(_component_pots_chart, null, null, 512), [
            [_vShow, _ctx.selectedTabIndex == 1]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["helpText"]))
}